import 'symbol-observable';
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider as ReduxProvider } from "react-redux";
import App from "./app/App";
import { store } from "./app/store";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { ApolloProvider } from "@apollo/client";
import client from "./app/graphql/client";
import { setupDebugTools } from "./utils/debugTools";
import { PostHogProvider } from "posthog-js/react";
import { FeatureFlagProvider } from './contexts/FeatureFlagContext';
import { SubscriptionAccessProvider } from './contexts/SubscriptionAccessContext';
import { NotificationProvider } from './contexts/NotificationContext';

// Custom Router, um die Blocker API zu verwenden
const router = createBrowserRouter([
    {
        path: "*",
        element: <App />
    }
]);

const options = {
    api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
};

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

setupDebugTools();

const AppContent = (
    <ApolloProvider client={client}>
        <ReduxProvider store={store}>
            <FeatureFlagProvider>
                <SubscriptionAccessProvider>
                    <NotificationProvider>
                        <RouterProvider router={router} />
                    </NotificationProvider>
                </SubscriptionAccessProvider>
            </FeatureFlagProvider>
        </ReduxProvider>
    </ApolloProvider>
);

root.render(
    <React.StrictMode>
        {process.env.REACT_APP_PUBLIC_POSTHOG_KEY ? (
            <PostHogProvider
                apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY}
                options={options}
            >
                {AppContent}
            </PostHogProvider>
        ) : (
            AppContent
        )}
    </React.StrictMode>,
);
